module.exports = __webpack_public_path__ + "img/badge5.c96f6f37.png";